"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportTypes = exports.SocialLoginType = exports.UpsertBulkUserAction = exports.PermissionType = void 0;
__exportStar(require("./claims"), exports);
__exportStar(require("./customer"), exports);
__exportStar(require("./utils"), exports);
__exportStar(require("./schemas"), exports);
var PermissionType;
(function (PermissionType) {
    PermissionType["user"] = "user";
    PermissionType["office"] = "office";
    PermissionType["profile"] = "profile";
})(PermissionType = exports.PermissionType || (exports.PermissionType = {}));
var UpsertBulkUserAction;
(function (UpsertBulkUserAction) {
    UpsertBulkUserAction["NO_CHANGES"] = "NO_CHANGES";
    UpsertBulkUserAction["CREATE"] = "CREATE";
    UpsertBulkUserAction["UPDATE"] = "UPDATE";
    UpsertBulkUserAction["CREATED"] = "CREATED";
    UpsertBulkUserAction["RECREATE"] = "RECREATE";
    UpsertBulkUserAction["RECREATED"] = "RECREATED";
    UpsertBulkUserAction["USER_NOT_EXISTS"] = "USER_NOT_EXISTS";
    UpsertBulkUserAction["REACTIVATE"] = "REACTIVATE";
})(UpsertBulkUserAction = exports.UpsertBulkUserAction || (exports.UpsertBulkUserAction = {}));
var SocialLoginType;
(function (SocialLoginType) {
    SocialLoginType["Microsoft"] = "MS";
    SocialLoginType["Google"] = "GOOGLE";
})(SocialLoginType = exports.SocialLoginType || (exports.SocialLoginType = {}));
var ReportTypes;
(function (ReportTypes) {
    ReportTypes["OFFICE"] = "office";
    ReportTypes["MANAGEMENT"] = "management";
    ReportTypes["CREDITOR"] = "creditor";
    ReportTypes["TEAMS"] = "teams";
})(ReportTypes = exports.ReportTypes || (exports.ReportTypes = {}));
